import React, { useEffect, useRef, useState } from 'react'
import { FaRegCalendarAlt, FaRegUser, FaWallet, FaRegStickyNote } from 'react-icons/fa';
import './i18n';  //// import i18n (needs to be bundled ;)) 
import { useTranslation } from 'react-i18next';

import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";

import { useAppCtx } from './app-ctx';
import VerificationModal from './verification-modal';
import CriteriaDateRange from './criteria-date-range';
import BookGuestSelector from './book-guest-selector';
import BookPriceSelector from './book-price-selector';

import safeStringify from './utils/safe-stringify';
import { da } from 'date-fns/locale';
import { set } from 'date-fns';
import { utf8_to_b64, b64_to_utf8 } from './utils/util';
import { use } from 'i18next';


import { filterBoardingsForGuest } from './utils/boardings';
import { dateOfBirthFromAge, ageFromDateOfBirth, isValidIsoDate } from './utils/guest-details';

// Section icon style: light (regular) icons on transparent background
// with dark grey lines.
const sectionIconStyle = { color: '#4a4a4a', fontSize: 20, verticalAlign: 'middle', marginRight: 8 };

/**
 * @param occupacyValue:
 *  {value: 1, stadard: true, rooms: 1, adults: 2, children: 1}
 * @param boardings:
 *  [{board_id, name, description, lang, db_row_id, resort_id },... ]
 *  ** board_id is likely that we have to pass to SBS API directly.
 *  ** name amove is actually the board code 'BBT, HB, FBT, ...
 * @param treatmentFrom number|null resort `treatment_from` property
 * @returns
 *  [{ id: age, boardId, boardName},....]
 */
function initGuestList(occupacyValue, boardings, treatmentFrom) {
  const result = [];

  if (!occupacyValue)
    return result;

  let index = 1;
  const { adults = 0, children = 0 } = occupacyValue;

  // Personal detail fields defaults; the Date of Birth is guessed
  // automatically from the age field.
  const details = (age) => ({
    firstName: '',
    secondName: '',
    phone: '',
    dob: dateOfBirthFromAge(age),
    passport: '',
    passportExpire: '',
  });

  // Add adults
  for (let i = 0; i < adults; i++) {
    const allowed = filterBoardingsForGuest(boardings, 18, treatmentFrom);
    result.push({ id:index++, age: 18, ...details(18), boardId: allowed.length > 0 ? allowed[0].board_id : null });
  }

  // Add children
  for (let i = 0; i < children; i++) {
    const allowed = filterBoardingsForGuest(boardings, 15, treatmentFrom);
    result.push({ id:index++, age: 15, ...details(15), boardId: allowed.length > 0 ? allowed[0].board_id : null });
  }

  return result;
}


function handleFormSubmit(theForm){

        console.log('BookForm.handleLookup():searchCriterias'+ JSON.stringify(theForm));


        // post searchCriterias to /resorts page to let back-end  chance to do its job and reload the page
        const form = document.createElement("form");
        form.method = "POST";
        form.action = window.location.href;
        //form.target = "_blank"; // Open in a new tab

        const input = document.createElement("input");
        input.type = "hidden";
        input.name = "book_details";
        var valueB64 = utf8_to_b64( JSON.stringify(theForm) );
        input.value = valueB64
        console.log('BookForm:handleLookup():input.value:'+ input.value);
        form.appendChild(input);

        const submit = document.createElement("input");
        submit.type = "submit";
        submit.value = "book";
        form.appendChild(submit);

        document.body.appendChild(form);
        form.submit();

        document.body.removeChild(form); // Clean up
}

const BookForm = ({resortId, theResort}) => {
  const { t } = useTranslation();
  const {JOOMLA_VARS, CONFIG, SearchDefaults, searchCriterias} = useAppCtx();

  

  //console.log(`BookForm().Entry: resortId=${theResort.resortId}, searchCriterais=, ${safeStringify(searchCriterias, 3)}`);
  console.log(`BookForm().Entry: resortId=${resortId}, searchCriterais=, ${JSON.stringify(searchCriterias)}, SearchDefaults=, ${JSON.stringify(SearchDefaults)}`);

  const occupacyValue = searchCriterias?.occupacyValue ?? { adults: 2, children: 1 };
  
  const defaultDietary = SearchDefaults?.dietaryTreatmentSettings?.dietaryOptions?.[0] || {};
  const userDietary = searchCriterias?.dietaryValue || {};
  const dietaryValue = {
    meals: userDietary.meals ?? defaultDietary.meals,
    treatment: userDietary.treatment ?? defaultDietary.treatment,
  };

  const roomNotSelected = {roomId: null, /** name, price, etc... */}
  const f = {
    resortId: resortId,
    resortName: theResort.name,
    resortAddress: theResort.address,
    guests: initGuestList(occupacyValue, theResort.boardings, theResort.treatment_from),
    dateRangeValue: searchCriterias?.dateRangeValue ?? SearchDefaults.dateRangeDefault,
    name: '',
    email: '',
    phone: '',
    message: '',
    terms: false,
    roomDetails: roomNotSelected
  }

  const formFromBackend = JOOMLA_VARS.form;
  const userProfile = JOOMLA_VARS.userProfile || null;

  // Backend re-submitted values (after a failed submit) take priority over the
  // logged-in user's profile; profile data only pre-fills fields left empty.
  const backendForm =
    formFromBackend && typeof formFromBackend === 'object' && !Array.isArray(formFromBackend)
      ? formFromBackend
      : {};
  const initialForm = {
    ...f,
    ...backendForm,
    name:  backendForm.name  ?? userProfile?.name  ?? '',
    email: backendForm.email ?? userProfile?.email ?? '',
    phone: backendForm.phone ?? userProfile?.phone ?? '',
  };

  // Make sure every guest carries the personal detail fields (older
  // re-submitted form payloads may miss them) so all inputs stay controlled.
  initialForm.guests = (Array.isArray(initialForm.guests) ? initialForm.guests : []).map((g) => ({
    firstName: '', secondName: '', phone: '',
    dob: dateOfBirthFromAge(g.age),
    passport: '', passportExpire: '',
    ...g,
  }));
  
  console.log(`BookForm().Entry: initialForm=, ${JSON.stringify(initialForm)}`);

  const [form, setForm] = useState(initialForm);
  const [errors, setErrors] = useState( JOOMLA_VARS.validationErrors );
  const [updatePrices, setUpdatePrices] = useState(0);

  // Contact verification popup state (phone/email pickup rules).
  const csrfToken = JOOMLA_VARS.csrfToken || '';
  const appRoot = JOOMLA_VARS.root;
  const [modal, setModal] = useState({
    open: false,
    needsPhone: false,
    needsEmail: false,
    maskedPhone: '',
    maskedEmail: '',
    smsResendDelay: 120,
    emailResendDelay: 120,
    error: '',
  });
  const [modalNonce, setModalNonce] = useState(0);
  const [submitting, setSubmitting] = useState(false);

  const postJson = (config, payload) =>
    fetch(appRoot + config, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken,
      },
      body: JSON.stringify(payload),
    }).then((r) => r.json());

  const closeVerificationModal = () =>
    setModal((m) => ({ ...m, open: false, error: '' }));

  // `react-phone-number-input` forwards this ref directly to the number
  // input element rendered with the `.PhoneInputInput` CSS class.
  const phoneInputRef = useRef(null);

  // When the country `<select>` gains focus via keyboard (Tab), move focus
  // straight to the number field. `detail === 0` indicates keyboard focus,
  // so mouse clicks keep their default behavior and the flag dropdown
  // still opens normally.
  const focusPhoneNumberInput = (event) => {
    if (event.detail === 0) {
      phoneInputRef.current?.focus();
    }
  };

  // For guests (and logged-in users without a stored phone) guess the phone's
  // country code from the visitor's IP, so the phone field is pre-configured
  // with the right dialing country. The GeoIP service sees the real client IP.
  const [defaultCountry, setDefaultCountry] = useState('UA');
  useEffect(() => {
    if (userProfile?.phone) {
      // The full international phone number already carries the country.
      return;
    }

    // Abort the GeoIP lookup on unmount so its response never touches an
    // unmounted component.
    const controller = new AbortController();
    fetch('https://ipapi.co/json/', { signal: controller.signal })
      .then((response) => response.json())
      .then((data) => {
        if (data && data.country_code) {
          console.log(`BookForm(): guessed phone country from IP: ${data.country_code}`);
          setDefaultCountry(data.country_code);
        }
      })
      .catch((error) => {
        // Ignore cancellations caused by cleanup (unmount)
        if (error && error.name === 'AbortError') return;
        console.warn('BookForm(): GeoIP lookup failed, keeping default country UA', error);
      });

    return () => {
      controller.abort();
    };
  }, []);

  const setGuests = (guests) => {
    setForm({...form, guests: guests});
  }

  const handleGuestsListChange = (guests) => {
    console.log('BookForm().handleGuestsListChange(): newValue=', JSON.stringify(guests));
    setForm({...form, guests: guests});
    setUpdatePrices(updatePrices + 1);
  }
  const handleDateRangeChange = (startDate, endDate) => {
    setForm({...form, dateRangeValue: {checkInDate:startDate, checkOutDate: endDate} });
    setUpdatePrices(updatePrices + 1);
  }
  const handlePersoneNameChange = (event) => {
    console.log('BookForm().handlePersoneNameChange(): newValue=', event.target.value);
    setForm({...form, name: event.target.value});
  }
  const handleEmailChanhge = (event) => {
    console.log('BookForm().handleEmailChanhge(): newValue=', event.target.value);
    setForm({...form, email: event.target.value});
  }
  const handleMessageTextChange = (event) => {
    //console.log('BookForm().handleMessageTextChange(): newOptions=', safeStringify(newOptions));
    setForm({...form, message: event.target.value});
  }
  const handleTermsChange = (event) => {
    console.log('BookForm().handleTermsChange(): newValue=', event.target.checked);
    setForm({...form, terms: event.target.checked});
  }
  // The room details kept in the form state are the ones that get submitted
  // (and saved into #__booking_requests.form), so the update must never be
  // merged into a stale copy of the form: the price list can be recalculated
  // while the user edits other fields (BookPriceSelector re-applies the
  // selected room on every refreshed list).
  const handleRoomChange = (roomDetails) => {
    console.log('BookForm().handleRoomChange(): newValue=', JSON.stringify(roomDetails));
    setForm((prev) => ({ ...prev, roomDetails }));
  }

  const [acceptedTerms, setAcceptedTerms] = useState(false);

  const validateForm = () => {
    const newErrors = {};

    //TODO: errors.dates, errors.price,

    if (!form.name.trim()) {
        newErrors.name = t("Name is required");
    }
    if (!form.email.trim()) {
        newErrors.email = t("Email is required");
    } else if (!/\S+@\S+\.\S+/.test(form.email)) {
        newErrors.email = t("Invalid email format");
    }
    if (!form.phone || form.phone.trim() === "") {
        newErrors.phone = t("Phone number is required");
    }
    // message is optional
    if (!form.terms) { 
      newErrors.terms = t("You must accept the terms and conditions");
    }
    if (!form.roomDetails.room_id) {
      newErrors.roomDetails = t("Please sellect one of the possible appartments");
    }

    if (!form.dateRangeValue || !form.dateRangeValue.checkInDate || !form.dateRangeValue.checkOutDate) {
      newErrors.dateRangeValue = t("Please select a valid date range");
    }
    const dateRange = form.dateRangeValue;
    if (dateRange) {
      const checkInDate = new Date(dateRange.checkInDate);
      const checkOutDate = new Date(dateRange.checkOutDate);
      if (checkInDate < Date.now() || checkOutDate < Date.now()) {
        newErrors.dateRangeValue = t("Dates must be in the future");
      }
      if (checkInDate >= checkOutDate) {
        newErrors.dateRangeValue = t("Check-in date must be before check-out date");
      }
    }

    if (!form.guests || form.guests.length === 0) {
      newErrors.guests = t("Guests list should not be empty");
    } else {
      let hasAdult = false;
      form.guests.forEach(guest => {
        if (guest.age >= 18) {
          hasAdult = true;
        }
      });
      if (!hasAdult) {
        newErrors.guests = t("At least one person must be over 18 years old");
      }

      // Boarding package visibility rules (must mirror server-side checks):
      // only board_id [1..6] and 255 are allowed; board_id [4..6] require
      // guest age >= resort treatment_from.
      form.guests.forEach((guest, idx) => {
        if (newErrors.guests) return;
        const allowed = filterBoardingsForGuest(theResort.boardings, guest.age, theResort.treatment_from);
        const selected = allowed.find((b) => parseInt(b.board_id, 10) === parseInt(guest.boardId, 10));
        if (!selected) {
          newErrors.guests = t("Invalid package selected for guest #") + (idx + 1);
        }
      });

      // Per-guest personal details (must mirror server-side checks in
      // BookStrategy::validateForm()). The guest phone is optional and
      // intentionally NOT validated.
      let guestDetailsErrors = null;
      form.guests.forEach((guest) => {
        const gErr = {};
        if (!String(guest.firstName ?? '').trim()) {
          gErr.firstName = t("First name is required");
        }
        if (!String(guest.secondName ?? '').trim()) {
          gErr.secondName = t("Second name is required");
        }
        const dob = String(guest.dob ?? '').trim();
        if (!dob) {
          gErr.dob = t("Date of Birth is required");
        } else {
          const derivedAge = ageFromDateOfBirth(dob);
          if (derivedAge === null) {
            gErr.dob = t("Date of Birth is invalid");
          } else if (parseInt(guest.age, 10) !== derivedAge) {
            // The date of birth and the age field must stay in sync.
            gErr.dob = t("Date of Birth does not match the age");
          }
        }
        if (!String(guest.passport ?? '').trim()) {
          gErr.passport = t("Passport number is required");
        }
        const expire = String(guest.passportExpire ?? '').trim();
        if (!expire) {
          gErr.passportExpire = t("Passport expire date is required");
        } else if (!isValidIsoDate(expire)) {
          gErr.passportExpire = t("Passport expire date is invalid");
        }
        if (Object.keys(gErr).length > 0) {
          guestDetailsErrors = guestDetailsErrors || {};
          guestDetailsErrors[guest.id] = gErr;
        }
      });
      if (guestDetailsErrors) {
        newErrors.guestDetails = guestDetailsErrors;
      }
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const submitBooking = () => {
    setSubmitting(false);
    handleFormSubmit(form);
  };

  const handleVerificationConfirm = async (phoneCode, emailCode) => {
    const data = await postJson(CONFIG.verifyBookingContact, {
      phone: form.phone,
      phoneCode,
      email: form.email,
      emailCode,
    });
    if (data.status === 'verified') {
      closeVerificationModal();
      submitBooking();
    } else {
      setModal((m) => ({
        ...m,
        error:
          data.errors?.code || data.errors?.phone || data.errors?.email
          || data.errors?.form || t('Invalid verification code'),
      }));
    }
  };

  const handleVerificationResend = async (scope) => {
    const data = await postJson(CONFIG.resendBookingVerification, { scope });
    if (data.status === 'sent') {
      setModalNonce((n) => n + 1);
      setModal((m) => ({
        ...m,
        smsResendDelay: scope === 'phone' ? data.resendDelay || m.smsResendDelay : m.smsResendDelay,
        emailResendDelay: scope === 'email' ? data.resendDelay || m.emailResendDelay : m.emailResendDelay,
        error: '',
      }));
    } else {
      setModal((m) => ({
        ...m,
        error: data.errors?.phone || data.errors?.email || data.errors?.form || t('Resend failed'),
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('BookForm().handleSubmit(): form=', safeStringify(form));
    if (!validateForm()) {
      console.warn("Form validation failed:", errors);
      return;
    }
    if (submitting) {
      return;
    }
    setSubmitting(true);

    try {
      // Ask the backend to apply the contact pickup rules before the actual
      // booking submission. Depending on the submitted phone/email it either
      // binds an existing account, accepts the contacts as-is, or starts the
      // SMS/email verification procedure.
      const data = await postJson(CONFIG.applyBookingContact, {
        phone: form.phone,
        email: form.email,
      });

      if (data.status === 'matched' || data.status === 'ok') {
        submitBooking();
        return;
      }

      if (data.status === 'verification_required') {
        setModalNonce((n) => n + 1);
        setModal({
          open: true,
          needsPhone: !!data.needsPhone,
          needsEmail: !!data.needsEmail,
          maskedPhone: data.maskedPhone || '',
          maskedEmail: data.maskedEmail || '',
          smsResendDelay: data.smsResendDelay || 120,
          emailResendDelay: data.emailResendDelay || 120,
          error: '',
        });
        setSubmitting(false);
        return;
      }

      // Validation errors from the backend (invalid format, contacts in use).
      setErrors((current) => ({ ...current, ...(data.errors || {}) }));
      setSubmitting(false);
    } catch (err) {
      console.warn('BookForm().handleSubmit(): contact check failed', err);
      setSubmitting(false);
    }
  };

  useEffect(() => {
    setUpdatePrices(updatePrices + 1);
  }, [form.guests]);


  return (
    <form onSubmit={handleSubmit} action='/book' method='POST' className="book-form">
      <h2><FaRegCalendarAlt style={sectionIconStyle} />{t("Booking Details")}</h2>
      {errors?.form && <div className="error-text">{errors.form}</div>}
      <fieldset>
        <legend className="guests-legend"><FaRegUser style={sectionIconStyle} />{t("Guests")}</legend>
        {/* 
            +-------------------------------------------------------------+
            | form.guests:                                                |
            | [{id, age, boardId}, ...]                                 V |
            +-------------------------------------------------------------+
        */}
        <BookGuestSelector className="form-element" _guests={form.guests} boardings={theResort.boardings}
            defaultCountry={defaultCountry} treatmentFrom={theResort.treatment_from}
            onGuestsListChange={handleGuestsListChange} validationEerror={errors?.guests || false}
            guestErrors={errors?.guestDetails || null} />
        {errors.guests && <div className="error-text">{errors.guests}</div>}

        <legend><FaRegCalendarAlt style={sectionIconStyle} />{t("Check-in and Check-out Dates")}</legend>
        <CriteriaDateRange className="form-element" validationEerror={errors?.dates || false}
          {...(form.dateRangeValue ?? SearchDefaults.dateRangeDefault)}
            onDateSelected={handleDateRangeChange}
        />
        {errors.dates && <div className="error-text">{errors.dates}</div>}
      </fieldset>

      <fieldset>
        <legend><FaWallet style={sectionIconStyle} />{t("Prices")}</legend>
        <div>{t('Apartments available')}:</div>
        <BookPriceSelector className="form-element" resortId={resortId} resortName={theResort.name}
             setRoom={handleRoomChange} updatePrices={updatePrices} guests={form.guests} 
             dateRangeValue={form.dateRangeValue} validationEerror={errors?.roomDetails || false}
             selectedRoomId={form.roomDetails?.room_id || null}
             defaultRooms={theResort.rooms} />
        {errors.roomDetails && <div className="error-text">{errors.roomDetails}</div>}
      </fieldset>

      <fieldset>
        <legend><FaRegUser style={sectionIconStyle} />{t("Contact Information")}</legend>
        <div className="form-element">
            <input className={`input-text ${errors.name ? 'error' : ''}`} type="text" name="name" 
                value={form.name} placeholder={t("Your name")} onChange={handlePersoneNameChange} />
            {errors.name && <div className="error-text">{errors.name}</div>}
        </div>
        <div className="form-element">
            <input className={`input-text input-email ${errors.email ? 'error' : ''}`} type="email" name="email" 
                value={form.email} placeholder={t("Your email")} onChange={handleEmailChanhge} />
            {errors.email && <div className="error-text">{errors.email}</div>}
        </div>
        <div className="form-element">
          <div className={`phone-input-wrapper ${errors.phone ? 'error' : ''}`} >
            <PhoneInput international ref={phoneInputRef} className="" defaultCountry={defaultCountry} placeholder="+380 XX XXX XXXX"
                value={form.phone} onChange={(v) => {setForm({...form, phone: v})}}
                countrySelectProps={{ onFocus: focusPhoneNumberInput }}
              />
          </div>
          {errors.phone && <div className="error-text">{errors.phone}</div>}
        </div>
      </fieldset>

      <fieldset>
        <legend><FaRegStickyNote style={sectionIconStyle} />{t("Other details")}</legend>
        <div className="form-element">
            <textarea className={`text-area ${errors.message ? 'error' : ''}`}
                    name="message" 
                    placeholder={t('Additional information that may be useful to us')} 
                    value={form.message} onChange={handleMessageTextChange} />
            {errors.message && <div className="error-text">{errors.message}</div>}
        </div>

      <div className="form-element">
          <label>
            <input className={`checkbox ${errors.terms ? 'error' : ''}`} name="terms" 
              checked={form.terms} onChange={handleTermsChange} type="checkbox" />
              <span className='checkbox-text'>{t("I accept the terms and conditions")}</span>
            {errors.terms && <div className="error-text">{errors.terms}</div>}
          </label>
      </div>

      <div className='form-element'>
        <button className="button is-primary" onClick={handleSubmit} disabled={submitting}>
          {t('Book Now')}
        </button>
      </div>
      </fieldset>

      <VerificationModal
        open={modal.open}
        needsPhone={modal.needsPhone}
        needsEmail={modal.needsEmail}
        maskedPhone={modal.maskedPhone}
        maskedEmail={modal.maskedEmail}
        smsResendDelay={modal.smsResendDelay}
        emailResendDelay={modal.emailResendDelay}
        nonce={modalNonce}
        error={modal.error}
        onResend={handleVerificationResend}
        onCancel={closeVerificationModal}
        onConfirm={handleVerificationConfirm}
      />
    </form>
  );
};

export default BookForm;
